import { render, staticRenderFns } from "./list_statis_zhichan.vue?vue&type=template&id=63a83961&scoped=true&"
import script from "./list_statis_zhichan.vue?vue&type=script&lang=js&"
export * from "./list_statis_zhichan.vue?vue&type=script&lang=js&"
import style0 from "./list_statis_zhichan.vue?vue&type=style&index=0&id=63a83961&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a83961",
  null
  
)

export default component.exports